import React, { useState } from "react";
import { useAuth } from "../lib/api";
import { KeyRound, LogOut } from "lucide-react";

export default function ChangePassword() {
  const { user, changePassword, logout } = useAuth();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!pwd || !pwd2) return setErr("Tüm alanları doldurun");
    if (pwd !== pwd2) return setErr("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      await changePassword(pwd);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10" style={{ backgroundColor: "hsl(var(--background))" }}>
      <div className="tk-card w-full max-w-md p-7 tk-rise" data-testid="change-password-card">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: "hsl(var(--surface-2))" }}>
            <KeyRound className="w-6 h-6" style={{ color: "hsl(var(--primary))" }} />
          </div>
          <div>
            <h1 className="text-xl font-display font-semibold">Merhaba {user?.display_name}</h1>
            <p className="text-sm" style={{ color: "hsl(var(--text-2))" }}>
              Güvenlik için yeni bir şifre belirleyin
            </p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="tk-label">Yeni Şifre</label>
            <input
              data-testid="new-password-input"
              type="password"
              className="tk-input"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
            />
          </div>
          <div>
            <label className="tk-label">Yeni Şifre (Tekrar)</label>
            <input
              data-testid="new-password-confirm-input"
              type="password"
              className="tk-input"
              value={pwd2}
              onChange={(e) => setPwd2(e.target.value)}
            />
          </div>
          <p className="text-xs" style={{ color: "hsl(var(--text-2))" }}>
            Herhangi bir uzunluk veya karakter seti kabul edilir — tamamen size kalmış.
          </p>
          {err && (
            <div data-testid="change-password-error" className="text-sm rounded-lg px-3 py-2" style={{ backgroundColor: "#FDECEA", color: "#9B2F28" }}>
              {err}
            </div>
          )}
          <button data-testid="change-password-submit-btn" disabled={loading} className="tk-btn w-full disabled:opacity-60">
            {loading ? "Kaydediliyor..." : "Şifreyi Kaydet ve Devam Et"}
          </button>
          <button type="button" onClick={logout} data-testid="change-password-logout-btn" className="tk-btn-ghost w-full flex items-center justify-center gap-2">
            <LogOut className="w-4 h-4" /> Çıkış
          </button>
        </form>
      </div>
    </div>
  );
}
